function getGAClientIDCore(w: Window): string | null {
  const googleAnalyticsEntryPointGetAll = w.ga?.getAll || (() => [])

  const trackers = googleAnalyticsEntryPointGetAll() || []

  if (trackers.length === 0) {
    return null
  }

  const trackerThatContainsClientId = trackers[0]

  if (!trackerThatContainsClientId.get) {
    return null
  }

  return trackerThatContainsClientId.get('clientId') || null
}

export const getGAClientId = (): string | null => {
  return getGAClientIDCore(window)
}

export const _test = { getGAClientIDCore }
